// panel-wrapper.component.ts utilizzato per il componente dinamico formly
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-panel-wrapper',
  template: `
    <div class="panel-wrapper">
      <div class="panel-header" *ngIf="to.label || to.description">
        <h2 class="panel-title" *ngIf="to.label">{{ to.label }}</h2>
        <p class="panel-description" *ngIf="to.description">{{ to.description }}</p>
      </div>
      <div class="panel-content">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
  styles: [`
    .panel-wrapper {
      border: 1px solid #d1d5db;
      border-radius: 12px;
      padding: 24px;
      margin-bottom: 24px;
      background: #ffffff;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    }
    .panel-header {
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 2px solid #f3f4f6;
    }
    .panel-title {
      margin: 0 0 8px 0;
      font-size: 20px;
      font-weight: 700;
      color: #111827;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }
    .panel-description {
      margin: 0;
      font-size: 14px;
      color: #6b7280;
      line-height: 1.5;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }
    .panel-content {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    /* Stili per i campi interni */
    :host ::ng-deep .mat-form-field {
      width: 100%;
    }
    
    :host ::ng-deep .mat-checkbox-label {
      font-weight: 500;
      color: #374151;
    }
    
    :host ::ng-deep .mat-form-field-label {
      font-weight: 500;
      color: #374151;
    }
    
    :host ::ng-deep .mat-form-field-outline {
      border-radius: 8px;
    }
    /* form.component.css */
    :host {
      display: block;
    }

    .form-container {
      max-width: 800px;
      margin: 0 auto;
      padding: 20px;
    }

    /* Margine per tutti i campi Formly */
    :host ::ng-deep formly-field {
      margin-bottom: 1.5rem;
      display: block;
    }

    /* Margine specifico per il wrapper primeng */
    :host ::ng-deep formly-wrapper-primeng-form-field {
      margin-bottom: 1.5rem;
    }
    /* nasconde TUTTI i pulsamenti dell'editor HTML, tranne i primi quattro */
    :host ::ng-deep formly-wrapper-primeng-form-field {
      .ql-toolbar.ql-snow {
        .ql-blockquote,
        .ql-code-block,
        .ql-header,
        .ql-list,
        .ql-script,
        .ql-indent,
        .ql-direction,
        .ql-size,
        .ql-color,
        .ql-background,
        .ql-font,
        .ql-align,
        .ql-clean,
        .ql-link,
        .ql-image,
        .ql-video {
          display: none !important;
        }
      }
    }
  `]
})
export class PanelWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', {read: ViewContainerRef}) fieldComponent: ViewContainerRef;
}


// WEBPACK FOOTER //
// ./src/app/views/challenge/panel-wrapper/panel-wrapper.component.ts